/**
 * Suspense fallback for the lazy-loaded /locations route (ZP-23's Leaflet
 * code-split). Was `fallback={null}` (a blank flash) until ZP-93 flagged
 * that against its own AC — "skeleton placeholders shown briefly rather
 * than a blank page." Shape roughly mirrors the real page's hero + map so
 * there's no visible layout jump once Locations.tsx finishes loading.
 */
export default function LocationsSkeleton() {
  return (
    <div aria-hidden="true" className="animate-pulse bg-gradient-to-b from-ocean-950 to-ocean-900 pt-32 pb-24 sm:pt-40 sm:pb-28">
      <div className="mx-auto max-w-2xl px-6 text-center">
        <div className="mx-auto h-3 w-24 rounded bg-white/10" />
        <div className="mx-auto mt-4 h-10 w-72 max-w-full rounded bg-white/10" />
        <div className="mx-auto mt-4 h-4 w-56 max-w-full rounded bg-white/10" />
      </div>
      <div className="mx-auto mt-16 h-[420px] max-w-6xl rounded-2xl bg-white/5 sm:h-[500px]" />
    </div>
  );
}
